import CopyButton from "@/components/CopyButton";
import { PromoBanner, PromoBannerWithDiscountCode } from "../types";

export function getPromoBannerObject(
  promoBanner: PromoBanner,
  LOBPromoBanner: PromoBannerWithDiscountCode | PromoBanner,
  secondLevelHtmlId?: string | undefined,
  secondLevelLocation?: string | undefined,
  incomingDiscountCode?: string,
) {
  const effectiveDiscountCode =
    incomingDiscountCode ||
    (LOBPromoBanner as PromoBannerWithDiscountCode).discountCode;
  return {
    ...promoBanner,
    ...LOBPromoBanner,
    secondLevel: undefined,
    firstLevel: undefined,
    cta: {
      label: LOBPromoBanner.cta?.label ?? "",
      url: LOBPromoBanner.cta?.url ?? "",
      html_id: secondLevelHtmlId,
      location: secondLevelLocation,
    },
    ctaElement: LOBPromoBanner.showCopyButton ? (
      <CopyButton
        text={effectiveDiscountCode}
        size={LOBPromoBanner.variant === "compact" ? "lg" : "sm"}
        buttonVariant={LOBPromoBanner.variant === "card" ? "default" : "brand"}
        htmlId={secondLevelHtmlId}
        location={secondLevelLocation}
      />
    ) : undefined,
  };
}
